<template>
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M7.64062 19.4193H4.37109V8.90759H7.64062V19.4193ZM5.98828 7.50134C4.96875 7.50134 4.125 6.62244 4.125 5.56775C4.125 4.54822 4.96875 3.70447 5.98828 3.70447C7.04297 3.70447 7.88672 4.54822 7.88672 5.56775C7.88672 6.62244 7.04297 7.50134 5.98828 7.50134ZM19.8398 19.4193H16.6055V14.3217C16.6055 13.0912 16.5703 11.5443 14.8828 11.5443C13.1953 11.5443 12.9492 12.8451 12.9492 14.2162V19.4193H9.67969V8.90759H12.8086V10.349H12.8438C13.3008 9.54041 14.3555 8.6615 15.9375 8.6615C19.2422 8.6615 19.875 10.8412 19.875 13.6537V19.4193H19.8398Z"
            fill="inherit"
        />
    </svg>
</template>
